import Collapse from "@material-ui/core/Collapse";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    closeAllRightPanels,
    getAppState,
} from "../../../../../common/appState";
import { fetchPost, fetchPostFormData } from "../../../../../common/util/fetch";
import { PrivateLessonInfo } from "../../../../zApps/Layout/Login/MyPage/MyPageTop/components/PrivateLesson/types";
import { PrimaryButton } from "../../../Button/PrimaryButton";
import { TextField } from "../../../Input/TextField";
import { validateImage } from "../../UserAvatar/validateImage";
import { OtherUser, User } from "../../types";

export function InfoForAdmin({
    targetUser,
    setTargetUser,
}: {
    targetUser: OtherUser;
    setTargetUser: (targetUser: OtherUser) => void;
}) {
    const [isDetailShown, setDetailShown] = useState(false);

    return (
        <>
            <PrivateLessonInfoForAdmin targetUser={targetUser} />
            <button
                onClick={() => {
                    setDetailShown(!isDetailShown);
                }}
                style={{ marginTop: 20 }}
            >
                {isDetailShown ? "less" : "more"}
            </button>

            <Collapse in={isDetailShown}>
                <Link to={`/logForAdmin/${targetUser.userId}`}>
                    <PrimaryButton
                        onClick={closeAllRightPanels}
                        style={{ marginTop: 20 }}
                    >
                        Log
                    </PrimaryButton>
                </Link>
                <SulInput
                    targetUser={targetUser}
                    setTargetUser={setTargetUser}
                />
                <AvatarChanger targetUserId={targetUser.userId} />
                <FullUserInfo targetUserId={targetUser.userId} />
            </Collapse>
        </>
    );
}

function FullUserInfo({ targetUserId }: { targetUserId: number }) {
    const [targetUserFullInfo, setTargetUserFullInfo] = useState<User | null>(
        null
    );
    const [memo, setMemo] = useState("");
    const [coins, setCoins] = useState(0);

    useEffect(() => {
        const form = new FormData();
        form.append("targetUserId", targetUserId.toString());

        fetchPostFormData<User & { memo: string }>(
            "api/User/GetUserByIdForAdmin",
            form
        ).then(result => {
            if ("error" in result) {
                return;
            }
            setTargetUserFullInfo(result);
            setMemo(result.memo);
            setCoins(result.coin);
        });
    }, [targetUserId]);

    const [submitting, setSubmitting] = useState(false);

    if (!targetUserFullInfo) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            <UserInfoRecord user={targetUserFullInfo} keyName="userId" />
            <UserInfoRecord user={targetUserFullInfo} keyName="email" />
            <UserInfoRecord user={targetUserFullInfo} keyName="coin" />
            <UserInfoRecord user={targetUserFullInfo} keyName="roulettePlay" />
            <UserInfoRecord
                user={targetUserFullInfo}
                keyName="friendExpansion"
            />
            <div>
                <textarea
                    value={memo}
                    onChange={ev => {
                        setMemo(ev.target.value);
                    }}
                    className="fullWidth"
                    rows={5}
                />
                <button
                    disabled={submitting}
                    onClick={async () => {
                        if (!confirm("Memoを保存しますか？")) {
                            return;
                        }
                        setSubmitting(true);

                        const result = await fetchUpdateMemo(
                            targetUserId,
                            memo
                        );
                        if ("error" in result) {
                            return;
                        }
                        setTargetUserFullInfo(result);
                        setMemo(result.memo);

                        setSubmitting(false);
                        alert("Success to update!");
                    }}
                >
                    {submitting ? "Submitting..." : "Save Memo"}
                </button>
            </div>
            <div style={{ marginTop: 20 }}>
                <input
                    type="number"
                    value={coins}
                    onChange={ev => {
                        setCoins(Number(ev.target.value));
                    }}
                />
                <button
                    disabled={submitting}
                    onClick={async () => {
                        if (!confirm("Coinsを保存しますか？")) {
                            return;
                        }
                        setSubmitting(true);

                        const result = await fetchUpdateCoins(
                            targetUserId,
                            coins - targetUserFullInfo.coin
                        );
                        if ("error" in result) {
                            return;
                        }
                        setTargetUserFullInfo(result);
                        setMemo(result.memo);

                        setSubmitting(false);
                        alert("Success to update!");
                    }}
                >
                    {submitting ? "Submitting..." : "Save Coins"}
                </button>
            </div>
        </div>
    );
}
async function fetchUpdateMemo(
    targetUserId: number,
    memo: string
): Promise<User & { memo: string }> {
    const formData = new FormData();
    formData.append("targetUserId", targetUserId.toString());
    formData.append("memo", memo);

    const res = await fetch("api/User/UpdateMemo", {
        method: "POST",
        body: formData,
    });
    return res.json();
}

async function fetchUpdateCoins(
    targetUserId: number,
    coinsToAdd: number
): Promise<User & { memo: string }> {
    const formData = new FormData();
    formData.append("targetUserId", targetUserId.toString());
    formData.append("coinsToAdd", coinsToAdd.toString());

    const res = await fetch("api/User/UpdateCoins", {
        method: "POST",
        body: formData,
    });
    return res.json();
}

function UserInfoRecord({
    keyName,
    user,
}: {
    keyName: keyof User;
    user: User;
}) {
    const value = user[keyName];
    return (
        <div>
            {keyName}: {typeof value === "string" ? value : value?.toString()}
        </div>
    );
}

function SulInput({
    targetUser,
    setTargetUser,
}: {
    targetUser: OtherUser;
    setTargetUser: (targetUser: OtherUser) => void;
}) {
    const [sul, setSul] = useState(targetUser.sul);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        setSul(targetUser.sul);
    }, [targetUser.sul]);

    return (
        <div style={{ marginTop: 20 }}>
            SUL:
            <input
                type="number"
                value={sul}
                style={{ marginLeft: 5 }}
                onChange={ev => {
                    setSul(Number(ev.target.value) || 0);
                }}
            />
            <button
                disabled={submitting}
                onClick={async () => {
                    if (!confirm("SULを保存しますか？")) {
                        return;
                    }
                    setSubmitting(true);

                    setTargetUser(await fetchUpdateSul(targetUser.userId, sul));

                    setSubmitting(false);
                    alert("Success to update!");
                }}
            >
                {submitting ? "Submitting..." : "Save SUL"}
            </button>
        </div>
    );
}
async function fetchUpdateSul(
    targetUserId: number,
    sul: number
): Promise<OtherUser> {
    const formData = new FormData();
    formData.append("targetUserId", targetUserId.toString());
    formData.append("sul", sul.toString());

    const res = await fetch("api/User/UpdateSul", {
        method: "POST",
        body: formData,
    });
    return res.json();
}

function PrivateLessonInfoForAdmin({ targetUser }: { targetUser: OtherUser }) {
    const [privateLessonInfo, setPrivateLessonInfo] =
        useState<PrivateLessonInfo | null>(null);
    const [memo, setMemo] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        const { user } = getAppState();
        if (!user) {
            return;
        }
        fetchPrivateLessonInfo(user.userId, targetUser.userId).then(result => {
            if (!result) {
                return;
            }
            setPrivateLessonInfo(result);
        });
    }, [targetUser.userId]);

    if (privateLessonInfo) {
        return (
            <div>
                <hr />
                {privateLessonInfo.specialPriceUSD > 0 && (
                    <div>
                        {`Special Price: ${privateLessonInfo.specialPriceUSD} (USD)`}
                    </div>
                )}
                <div
                    style={{
                        marginBottom: 10,
                        fontSize: "x-large",
                        fontWeight: "bold",
                    }}
                >
                    Current Tickets: {privateLessonInfo.tickets}
                </div>
                <div style={{ display: "flex", gap: 5 }}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        label="Memo"
                        onChange={ev => {
                            setMemo(ev.target.value);
                        }}
                        value={memo}
                        style={{ margin: 0 }}
                    />
                    <PrimaryButton
                        disabled={submitting || privateLessonInfo.tickets < 1}
                        onClick={async () => {
                            const { user } = getAppState();
                            if (!user) {
                                return;
                            }
                            setSubmitting(true);
                            const previousTickets = privateLessonInfo?.tickets;
                            const result = await fetchConsumeTicket(
                                user.userId,
                                targetUser.userId,
                                memo
                            );
                            setPrivateLessonInfo(result);
                            alert(
                                `Ticket: ${previousTickets} ⇒ ${result?.tickets}`
                            );
                            setMemo("");
                            setSubmitting(false);
                        }}
                    >
                        Reserve
                    </PrimaryButton>
                </div>
                <hr />
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                    }}
                >
                    {privateLessonInfo.ticketConsumption.map((t, i) => (
                        <div key={i}>{t.memo}</div>
                    ))}
                </div>
            </div>
        );
    }
    return (
        <FieldToEnableToBuy
            targetUser={targetUser}
            submitting={submitting}
            setSubmitting={setSubmitting}
            setPrivateLessonInfo={setPrivateLessonInfo}
        />
    );
}

async function fetchPrivateLessonInfo(
    myUserId: number,
    targetUserId: number
): Promise<PrivateLessonInfo | null> {
    const privateLessonInfo = await fetchPost<
        { myUserId: number; targetUserId: number },
        PrivateLessonInfo
    >("api/PrivateLesson/GetPrivateLessonInfo", { myUserId, targetUserId });

    if ("error" in privateLessonInfo) {
        return null;
    }
    return privateLessonInfo;
}

async function fetchConsumeTicket(
    myUserId: number,
    targetUserId: number,
    memo: string
): Promise<PrivateLessonInfo | null> {
    const privateLessonInfo = await fetchPost<
        { myUserId: number; targetUserId: number; memo: string },
        PrivateLessonInfo
    >("api/PrivateLesson/ConsumeTicket", { myUserId, targetUserId, memo });

    if ("error" in privateLessonInfo) {
        return null;
    }
    return privateLessonInfo;
}

function FieldToEnableToBuy({
    targetUser,
    submitting,
    setSubmitting,
    setPrivateLessonInfo,
}: {
    targetUser: OtherUser;
    submitting: boolean;
    setSubmitting: (submitting: boolean) => void;
    setPrivateLessonInfo: (info: PrivateLessonInfo | null) => void;
}) {
    const [specialPriceUSD, setSpecialPriceUSD] = useState(0);

    return (
        <div>
            <hr />
            <div style={{ marginBottom: 10, fontSize: "large" }}>
                {"Special Price (USD): "}
                <input
                    type="number"
                    value={specialPriceUSD}
                    onChange={ev => {
                        setSpecialPriceUSD(Number(ev.target.value));
                    }}
                />
            </div>
            <PrimaryButton
                disabled={submitting}
                onClick={async () => {
                    const { user } = getAppState();
                    if (!user) {
                        return;
                    }
                    setSubmitting(true);
                    const result = await fetchRegisterNewStudent(
                        user.userId,
                        targetUser.userId,
                        specialPriceUSD
                    );
                    setPrivateLessonInfo(result);
                    setSubmitting(false);
                }}
            >
                Enable to buy tickets
            </PrimaryButton>
        </div>
    );
}
async function fetchRegisterNewStudent(
    myUserId: number,
    targetUserId: number,
    specialPriceUSD: number
): Promise<PrivateLessonInfo | null> {
    const privateLessonInfo = await fetchPost<
        { myUserId: number; targetUserId: number; specialPriceUSD: number },
        PrivateLessonInfo
    >("api/PrivateLesson/RegisterNewStudent", {
        myUserId,
        targetUserId,
        specialPriceUSD,
    });

    if ("error" in privateLessonInfo) {
        return null;
    }
    return privateLessonInfo;
}

function AvatarChanger({ targetUserId }: { targetUserId: number }) {
    return (
        <div>
            Change Avatar:{" "}
            <input
                type="file"
                accept="image/*"
                id={"avatarChanger"}
                onChange={({ target }) => {
                    if (!target.files || !target.files[0]) {
                        return;
                    }
                    const file = target.files[0];

                    const error = validateImage(file);
                    if (error) {
                        alert(error);
                        return;
                    }

                    fetchUpdateAvatar(targetUserId, file);
                }}
            />
        </div>
    );
}
async function fetchUpdateAvatar(
    targetUserId: number,
    file: File
): Promise<void> {
    const formData = new FormData();
    formData.append("targetUserId", targetUserId.toString());
    formData.append("file", file);

    await fetch("api/User/ChangeOtherUserAvatar", {
        method: "POST",
        body: formData,
    });

    alert("Success! Please reload!");
}
